import { useEffect } from "react";

// Company info for schema.org
const companyInfo = {
  name: "Serrurier Lieusaint",
  owner: "Vincent VALLES",
  address: {
    streetAddress: "23 Avenue René Cassin",
    postalCode: "77127",
    addressLocality: "Lieusaint",
    addressCountry: "FR"
  },
  phone: "+33668032561",
  email: "serrurierlieusaint@gmail.com",
  siret: "94505578800018",
  url: "https://serrurier-lieusaint.fr",
  priceRange: "€€",
  openingHours: "Mo-Su 00:00-23:59"
};

export const SEOHead = ({
  title = "Serrurier Lieusaint (77127) – Dépannage serrurerie urgence 24h/24",
  description = "Serrurier Lieusaint disponible 24h/24 pour ouverture de porte, changement de serrure et dépannage serrurerie. Intervention rapide à Lieusaint et dans toute la zone de Sénart. Appelez le 06 68 03 25 61.",
  canonical = "",
  type = "LocalBusiness"
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonical || window.location.href;

    // Add/Update JSON-LD schema
    let schemaScript = document.getElementById('schema-localbusiness');
    if (!schemaScript) {
      schemaScript = document.createElement('script');
      schemaScript.id = 'schema-localbusiness';
      schemaScript.type = 'application/ld+json';
      document.head.appendChild(schemaScript);
    }

    const schema = {
      "@context": "https://schema.org",
      "@type": type,
      "name": companyInfo.name,
      "image": "https://images.unsplash.com/photo-1561458338-cd061b02a655?w=800",
      "description": description,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": companyInfo.address.streetAddress,
        "addressLocality": companyInfo.address.addressLocality,
        "postalCode": companyInfo.address.postalCode,
        "addressCountry": companyInfo.address.addressCountry
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 48.6279,
        "longitude": 2.5494
      },
      "url": companyInfo.url,
      "telephone": companyInfo.phone,
      "email": companyInfo.email,
      "priceRange": companyInfo.priceRange,
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [],
      "areaServed": [
        "Lieusaint", "Moissy-Cramayel", "Savigny-le-Temple", "Combs-la-Ville",
        "Melun", "Cesson", "Nandy", "Tigery", "Vert-Saint-Denis", "Réau",
        "Corbeil-Essonnes", "Évry-Courcouronnes", "Brie-Comte-Robert"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "12",
        "bestRating": "5",
        "worstRating": "1"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Services de serrurerie",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Ouverture de porte",
              "description": "Ouverture de porte rapide et sans dégât 24h/24"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Changement de serrure",
              "description": "Remplacement de serrure par modèle certifié A2P"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Dépannage serrurerie",
              "description": "Intervention rapide pour tout problème de serrurerie"
            }
          }
        ]
      }
    };

    schemaScript.textContent = JSON.stringify(schema);

    // Cleanup
    return () => {
      // Keep the elements but they'll be updated on next render
    };
  }, [title, description, canonical, type]);

  return null;
};

export default SEOHead;
